export default {
  title: 'Menü daraus machen?',
  item_only: 'Nur Artikel',
  make_it_combo: 'Menü daraus machen?',
  or: 'order',
  buttons: {
    item_only: 'Nur Artikel',
    make_it_combo: 'Menü Deal',
  },
};
